<template>
  <div class="content-wrapper p-0">
    <div class="content">
      <h4 class="mb-3"><i class="fas fa-key mr-2"></i>API Keys</h4>
      <!-- Keyed by clinicUrl so the manager fully remounts when the chain admin switches clinic. -->
      <ApiKeyManager
        :key="clinicUrl"
        level="clinic"
        :clinic-url="clinicUrl"
        @revealed-change="v => (revealed = v)"
      />
      <Dialog ref="Dialog" />
    </div>
  </div>
</template>

<script>
import ApiKeyManager from "@/components/apiKeys/ApiKeyManager.vue";
import Dialog from "@/components/modal/Dialog";

// Chain clinics: /:clinicUrl/central/api-keys, gated by api_key.manage.clinic (C_LEVEL).
export default {
  name: "ClinicApiKeys",
  components: { ApiKeyManager, Dialog },
  data() {
    return { revealed: false };
  },
  // Leaving the route unmounts the manager and loses the one-time key.
  async beforeRouteLeave(to, from, next) {
    if (!this.revealed) return next();
    const result = await this.$refs.Dialog.showAlertConfirm(
      "ออกจากหน้านี้?",
      "คุณคัดลอก API Key เก็บไว้แล้วหรือยัง? ออกจากหน้านี้แล้วจะดูคีย์นี้อีกไม่ได้",
      "warning",
      "คัดลอกแล้ว ออกจากหน้านี้",
      "อยู่หน้านี้ต่อ"
    );
    next(!!(result && result.isConfirmed));
  },
  computed: {
    clinicUrl() {
      return this.$route.params.clinicUrl;
    },
  },
};
</script>
